import { BaseComponent } from "../../Library/BaseComponent";
import { OnInit, Component, Input, EventEmitter, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { MasterDataService } from "../../Services/MasterDataService";
import { StaffHealthDataService } from "../../Services/StaffHealthDataService";
import { QuestionSetLookupResponse, StaffQuestionaireTemplate } from "../../Models/ResponseModels";
import * as _ from "lodash";
import { QuestionSetStatus } from "../../Models/EnumModels";

@Component({
    selector: 'QuestionnaireSearchResult',
    templateUrl: './QuestionnaireSearchResult.html'
})
export class QuestionnaireSearchResult extends BaseComponent implements OnInit {

    @Input() RequestModel;
    @Input() set FilterModel(data) {
        if (!data) {
            return
        }
        let hasChanges = false;
        if (this.LocalFilterModel.SelectedTabId != data.SelectedTabId) {
            this.LocalFilterModel.SelectedTabId = data.SelectedTabId;
            hasChanges = true;
        }
        if (this.LocalFilterModel.KeywordSearch != data.KeywordSearch) {
            this.LocalFilterModel.KeywordSearch = data.KeywordSearch;
            hasChanges = true;
        }

        if (hasChanges) {
            this.applyLocalFilters();
        }
    }

    @Output() onSelected = new EventEmitter();
    @Output() onCountUpdate = new EventEmitter();

    ResponseModel?: QuestionSetLookupResponse;
    ActiveQuestionSet?: StaffQuestionaireTemplate;
    LocalDatasource?: StaffQuestionaireTemplate[];
    SelectedQuestionSet?: StaffQuestionaireTemplate;
    DateFormat: string;
    QuestionSetStatus = QuestionSetStatus;

    LocalFilterModel: any = {
        PageNumber: 1,
        PageSize: 25
    }

    SortParams = []

    constructor(
        public translate: TranslateService,
        public toastr: ToastrService,
        public route: ActivatedRoute,
        public router: Router,
        public masterService: MasterDataService,
        protected staffHealthService: StaffHealthDataService) {
        super(translate, toastr, route, router, masterService);
    }

    @Input() setRequestModel(model): void {
        this.RequestModel = model;
        this.setData()
    }

    setData() {
        if (!this.RequestModel || !this.RequestModel.PropertyId) {
            return;
        }
        this.DateFormat = this.masterService.GetPropertyDateFormat(this.RequestModel.PropertyId)
        this.IsSubmitting = true;
        this.staffHealthService.GetQuestionairesForProperty(this.RequestModel.PropertyId, true)
            .then(
                data => {
                    this.IsSubmitting = false;
                    if (data && data.HasError) {
                        this.FormErrors = data.Errors;
                        return;
                    }
                    this.ResponseModel = data;

                    // uncomment when status tabbar is enabled
                    // this.updateDataCounts();

                    // if selected question, then force update it
                    const datasource = data.Result && data.Result.StaffQuestionaireTemplates;

                    if (this.SelectedQuestionSet) {    
                        const newSelected = _.find(datasource, { Id: this.SelectedQuestionSet.Id });
                        if (newSelected) {
                            newSelected['forceUpdate'] = true;
                        }
                        
                        this.onRowSelected(newSelected);
                    }

                    this.ActiveQuestionSet = _.find(datasource, { Status: QuestionSetStatus.Active });
                    // remove active question set from data source
                    if (this.ActiveQuestionSet) {
                        _.pull(data.Result.StaffQuestionaireTemplates, this.ActiveQuestionSet);
                    }

                    this.applyLocalFilters();
                },
                error => {
                    this.IsSubmitting = false;
                    console.error(error);
                }
            )

    }

    ngOnInit() { }

    onPageChange(event) {
        console.log(event);
    }

    onRowSelected(row: StaffQuestionaireTemplate) {
        this.SelectedQuestionSet = row;
        this.onSelected.emit(row);
    }

    updateDataCounts() {
        let all = 0, active = 0, pending = 0;
        if (this.ResponseModel && this.ResponseModel.Result && this.ResponseModel.Result.StaffQuestionaireTemplates) {
            const templates = this.ResponseModel.Result.StaffQuestionaireTemplates;
            all = templates.length;
            active = templates.filter(t => t.Status == QuestionSetStatus.Active).length;
            pending = templates.filter(t => t.Status == QuestionSetStatus.Pending).length;
        }
        this.onCountUpdate.emit({ all, active, pending });
    }

    updateQuestionnaires(action: string, affectedQuestionnaireId: number) {
        let questionnaireIds = [affectedQuestionnaireId];
        // ... todo
    }

    applyLocalFilters() {
        if (!(this.ResponseModel && this.ResponseModel.Result && this.ResponseModel.Result.StaffQuestionaireTemplates)) {
            return;
        }
        const datasource = this.ResponseModel.Result.StaffQuestionaireTemplates;
        let filtered: any[] = _.cloneDeep(datasource);
        // filter on basis of status
        if (this.LocalFilterModel.SelectedTabId) {
            filtered = _.filter(filtered, {
                Status: this.LocalFilterModel.SelectedTabId
            });
        }
        // filter on basis of name
        if (this.LocalFilterModel.KeywordSearch) {
            const query = _.lowerCase(this.LocalFilterModel.KeywordSearch);
            filtered = _.filter(filtered, (qs => _.lowerCase(qs.TemplateName).indexOf(query) >= 0));
        }
        // apply sort
        filtered = filtered.sort((a, b) => {
            return b.CreatedOnDate.getTime() - a.CreatedOnDate.getTime();
        })

        // chunk on basis of page-number
        if (this.LocalFilterModel.PageNumber && this.LocalFilterModel.PageSize) {
            const chunks = _.chunk(filtered, this.LocalFilterModel.PageSize);
            if (this.LocalFilterModel.PageNumber > 0 && this.LocalFilterModel.PageNumber <= chunks.length) {
                filtered = chunks[this.LocalFilterModel.PageNumber - 1];
            }
        }

        this.LocalDatasource = filtered;
    }
}
